import { render } from "./NewVisit.vue?vue&type=template&id=72b50528"
import script from "./NewVisit.vue?vue&type=script&lang=js"
export * from "./NewVisit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__